import React from "react";
import Page from "components/Page";
import { Props } from "./AssetCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const AssetCustomTypes = lazyWithRetry(() => import("./AssetCustomTypes"));

export default (props: Props) => (
  <Page>
    <AssetCustomTypes {...props} />
  </Page>
);
